export const SUCCESS = 'success',
  FAILED = 'failed',
  PENDING = 'pending',
  REQUESTING = 'requesting';

// export function isDirty(status) {
//   return status === PENDING || status === FAILED;
// }
